import React, { useCallback } from 'react'
import TextButton from 'LuxKit/Button/TextButton'
import LineUploadIcon from 'LuxKit/Icons/line/LineUploadIcon'
import IconButton from 'LuxKit/Button/IconButton'
import { useIntl } from 'react-intl'

interface Props
  extends Omit<React.ComponentProps<typeof TextButton>, 'kind' | 'children'> {
  iconOnly?: boolean
}

function ExportMediaContentButton(props: Props) {
  const { onClick, iconOnly } = props
  const intl = useIntl()

  const onShareClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      onClick?.(e)
    },
    [onClick],
  )

  if (iconOnly) {
    return (
      <IconButton
        {...props}
        size="medium"
        shape="circle"
        kind="secondary"
        variant="dark"
        onClick={onShareClick}
      >
        <LineUploadIcon aria-hidden="true" />
      </IconButton>
    )
  }

  return (
    <TextButton
      kind="secondary"
      {...props}
      startIcon={<LineUploadIcon aria-hidden="true" />}
      onClick={onShareClick}
    >
      {intl.formatMessage({
        id: 'snrBa4zjYs',
        defaultMessage: 'Create Marketing Promo',
        description: 'Button to create a marketing promotional asset',
      })}
    </TextButton>
  )
}

export default ExportMediaContentButton
